export default __webpack_public_path__ + "static/media/FOODERP_BG.0e6b87df.jpg";